<template>
  <a @click="smoothScroll" :href="'#' + to" class="js-smooth-scroll |">
    <slot />
  </a>
</template>

<script type="text/babel">
import SmoothScroll from "smooth-scroll";
export default {
  props: {
    to: {
      required: true
    }
  },
  methods: {
    smoothScroll() {
        var scroll = new SmoothScroll('.js-smooth-scroll', {
            speed: 1500,
            speedAsDuration: true,
            easing: 'easeInOutQuad',
        });
    }
  }
};
</script>
